import CssClassMixin from '../../mixins/css_class_mixin.jsx';

var createClass = require('create-react-class');

window.GridTable = createClass({
  mixins: [CssClassMixin],

  getDefaultProps: function() {
    return {
      themeClassKey: 'grid.table'
    };
  },

  render: function() {
    return(
      <div className={this.className()}>
        <Table {...this.propsWithoutCSS()} className={this.props.tableClassName} clearTheme={this.props.clearThemeTable} />
      </div>
    );
  }
});
